import React from 'react';
import PropTypes from 'prop-types';

import InfoMessage from '../InfoMessage';

const NotFound = ({ t }) => {
  return (
    <div className='row'>
      <div className='col'>
        <InfoMessage type='notfound' t={t}></InfoMessage>
      </div>
    </div>
  );
};

NotFound.propTypes = {
  t: PropTypes.func
};

export default NotFound;
